
/** Opens the mobile menu */
export function openMobileMenu() {
    const menu = document.querySelector('.mobile-main-menu');
    menu.classList.add('open');

    document.body.classList.add('mobile-menu-open');
    document.documentElement.classList.add('mobile-menu-open');
}

/** Closes the mobile menu */
export function closeMobileMenu() {
    const menu = document.querySelector('.mobile-main-menu');
    menu.classList.remove('open');

    document.body.classList.remove('mobile-menu-open');
    document.documentElement.classList.remove('mobile-menu-open');
}
